import Editor from "@monaco-editor/react";

interface SqlEditorProps {
  setValue: (value: string) => void;
  value: string;
}

function SqlEditor({ setValue, value }: SqlEditorProps) {
  return (
    <div className="p-2 w-full bg-gray-200">
      <Editor
        height="325px"
        defaultLanguage="sql"
        defaultValue={value}
        onChange={(value) => setValue(value || "")}
        theme="vs-light"
        options={{
          fontSize: 16,
          minimap: { enabled: false },
          scrollbar: {
            vertical: "auto",
            horizontal: "auto",
          },
          scrollBeyondLastLine: false,
          wordWrap: "on",
          lineNumbers: "on",
          glyphMargin: false,
          folding: false,
          lineDecorationsWidth: 10,
          lineNumbersMinChars: 0,
        }}
        value={value}
      />
    </div>
  );
}

export default SqlEditor;
